import React, { useEffect, useState } from 'react';
import { Page, Card, Typography } from 'seagull';
import styles from "./ReferralDashboard.module.scss";
import { useStoreActions } from "../../store/store-context";
import { getHelpArticle, sendErrReport } from "../../infra/utils";
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
export default function ReferralDashboard() {
  const {
    api,
    logBI
  } = useStoreActions();
  const [referral, setReferral] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = 'Referrals';
    api.user.referral().then(referralData => {
      setReferral(referralData);
      setLoading(false);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Page, {
    header: "Referral Dashboard",
    subheader: "When a contact joins Anchor with your link and gets paid, you get credits. Nice!",
    skin: "secondary",
    "data-testid": "referral-dashboard",
    loading: loading
  }, /*#__PURE__*/React.createElement(Card, {
    title: "Spread Anchor, Get Rewarded.",
    autoHeight: true,
    padding: "m",
    className: styles.card
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Share your unique link with peers via email or social media and introduce them to Anchor! When they sign up, they'll receive a $50 Anchor credit as a welcome gift. Once they get their first payment, you'll also be rewarded with a $50 Anchor credit. Everyone wins!", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
    openInNewTab: true,
    href: getHelpArticle('8102891-what-is-anchor-s-referral-program')
  }, "Read more"))), /*#__PURE__*/React.createElement("div", {
    className: styles.innerCard
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    weight: "bold"
  }, "Share your unique referral link"), /*#__PURE__*/React.createElement(CopyToClipboard, {
    value: referral === null || referral === void 0 ? void 0 : referral.referralLink(),
    "data-testid": "referral-link",
    onError: () => sendErrReport('Failed to copy referral link'),
    onCopy: () => logBI(18150),
    disabled: loading
  }), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "credits-earned"
  }, "Credits earned so far: ".concat(referral ? referral.creditsEarnedFormatted() : '$0')))));
}